import {getCanvasAppParentOrigin} from '@packages/utilities/canvas-origin';
import {ExpressionElement} from '@packages/systems/wfdl-ast';

/**
 * Sends message to Designer App that user has clicked on the element in the Canvas that
 * corresponds to the given ExpressionElement.
 */
export const elementClickedOnCanvas = ({
  element,
}: {
  element: ExpressionElement;
}) => {
  const message = {method: 'elementClickedOnCanvas', element};
  const designerAppOrigin = getCanvasAppParentOrigin(window);

  if (designerAppOrigin) {
    window.parent.postMessage(message, designerAppOrigin);
  }
};
